import React from 'react';
import {
  TbClick,
  TbH1,
  TbH2,
  TbAlignLeft,
  TbPhoto,
  TbPhotoSquareRounded,
} from 'react-icons/tb';
import { ContentsModuleType } from 'types';

export const MODULE_ITEM_TYPE = 'MODULE';

export const MODULE_META: Record<
  ContentsModuleType,
  { label: string; icon: React.ReactNode }
> = {
  MAIN_IMAGE: { label: '메인 이미지', icon: <TbPhoto size={18} /> },
  SUB_IMAGE: { label: '이미지', icon: <TbPhotoSquareRounded size={18} /> },
  TITLE: { label: '타이틀', icon: <TbH1 size={18} /> },
  SUB_TITLE: { label: '서브 타이틀', icon: <TbH2 size={18} /> },
  TEXT: { label: '텍스트', icon: <TbAlignLeft size={18} /> },
  BUTTON: { label: '버튼', icon: <TbClick size={18} /> },
};

export const MODULE_GROUPS: { title: string; types: ContentsModuleType[] }[] = [
  { title: '텍스트', types: ['TITLE', 'SUB_TITLE', 'TEXT'] },
  { title: '미디어', types: ['MAIN_IMAGE', 'SUB_IMAGE'] },
  { title: '기타', types: ['BUTTON'] },
];
